import axios, { post, put } from 'axios';

export const CarBrandList = (params) => async (dispatch) => {
  try {
    return await axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/car-brands`, { params })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  } catch (error) {}
};

export const FindCarBrand = (id) => async (dispatch) => {
  try {
    return await axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/car-brands/${id}`)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  } catch (error) {}
};

export const CreateCarBrand = (data) => async (dispatch) => {
  try {
    return await post(`${process.env.REACT_APP_BASE_URL}/api/car-brands`, data)
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  } catch (error) {}
};

export const UpdateCarBrand =
  ({ id, data }) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      return await put(
        `${process.env.REACT_APP_BASE_URL}/api/car-brands/${id}`,
        data,
        config
      )
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (error) {}
  };
export const DestroyCarBrand = (id) => async () => {
  return await axios
    .delete(`${process.env.REACT_APP_BASE_URL}/api/car-brands/${id}`)
    .then((response) => {
      return Promise.resolve(response);
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};
